module.exports = __webpack_public_path__ + "static/media/assembly3.2e6dd537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly3.png
// module id = 2421
// module chunks = 0